import React from 'react';
import './hero.css';

const Hero = () => {
  return (
    <section className='hero__container'>
        <div className='hero__content content__page'>
            <div className="hero__title"><h1>215 anos</h1></div>
            <div className="hero__subtitle"><p>Na Rota do Futuro</p></div>
        </div>
    </section>
  )
}

export default Hero